export const validation = {
  countMaxChar: 8,
  titleMaxChar: 60,
  features: {
    min: 1,
    max: 4
  }
}
